const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCardsBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -14,
    width: 31,
    height: 29,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    d: "M6.8,3.8L8.3,3.8L8.3,5.3L6.8,5.3L6.8,3.8ZM6.8,6.8L8.3,6.8L8.3,11.3L6.8,11.3L6.8,6.8ZM7.5,0C3.4,0 0,3.4 0,7.5C0,11.6 3.4,15 7.5,15C11.6,15 15,11.6 15,7.5C15,3.4 11.6,0 7.5,0ZM7.5,13.5C4.2,13.5 1.5,10.8 1.5,7.5C1.5,4.2 4.2,1.5 7.5,1.5C10.8,1.5 13.5,4.2 13.5,7.5C13.5,10.8 10.8,13.5 7.5,13.5Z",
    style: {
      fill: "rgb(52,127,196)",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCardsBg);
export default __webpack_public_path__ + "static/media/Info_Cards_Bg.be59300a2a3b30c97269e6e59b9c0094.svg";
export { ForwardRef as ReactComponent };